const environment = process.env.CONFIG;
const informationApi = `${environment.env.internalProxyUrl}v1/user_experience/news/getNewsDetail`;
const informationListApi = `https:${environment.env.proxyUrl}/cal/awesome/pc/kaoyan/newsList`;
const informationLXListApi = `https:${environment.env.proxyUrl}/cal/awesome/pc/news/queryListByShort`;

// 资讯详情页ssr请求
const getInformationDetail = async function ({app, subject_id, information_id, pClient}) {
    try {
        const params = {
            cmsCatalogId: subject_id,
            informationId: information_id,
            os: 'h5-pc',
            p_client: pClient || 1
        };


        const {data = {}, code = '', msg = ''} = await app.axiosServer.$get(informationApi, {params});
        // 正常返回 & 资讯下架
        if (code === 0 || code === 1002) {
            let detailHtmlData = data.newsDetail?.url && await app.axiosServer.$get(data.newsDetail.url);
            detailHtmlData = detailHtmlData?.replace(/__openWindow/g, 'open') || '';
            return {
                informationStatus: code,
                newsDetail: data.newsDetail || {},
                newsRecommend: data.newsRecommend || [],
                disclaimers: data.disclaimers || [],
                categoryNameList: data.categoryNameList || [],
                detailHtmlData,
                loading: false
            };
        }
        return {
            categoryStatus: code,
            categoryMsg: msg
        };
    }
    catch (e) {
        return {
            categoryStatus: -1,
            categoryMsg: e.message || 'error'
        };
    }
};

// 资讯列表页ssr请求
const getInformationList = async function({app, pClient, pageId}) {
    try {
        const params = {
            pClient,
            pageId,
            tagListFlag: '1',
            hasTop: true,
            hasTopData: true,
            needNewsViewCount: true,
            categoryTagListFlag: Number(pClient == 7 || pClient === 16),
            needUrlShort: pClient == 7,
        };
        const {data = {}, code = '', msg = ''} = await app.axiosServer.$post(pClient == 7 ? informationLXListApi : informationListApi, params);

        if (code === 0) {
            return {
                ...data,
                tagList: data.tagGroupList
            };
            // return data;
        }
        return {
            page: {},
            tagList: [],
            newsList: []
        };
    }
    catch (e) {
        return {
            categoryStatus: -1,
            categoryMsg: e.message || 'error'
        };
    }
};

export default {
    getInformationDetail,
    getInformationList
};
